// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BV9oRONQig1CEEgqBo7f{margin:0}.pAIekIcNsJco5Wt2f8Id{height:32px;align-items:center;display:flex;padding-left:8px}`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/ui/DateFieldDropdown/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,QAAA,CAEF,sBACE,WAAA,CACA,kBAAA,CACA,YAAA,CACA,gBAAA","sourcesContent":[".icon {\n  margin: 0;\n}\n.labelDropdown {\n  height: 32px;\n  align-items: center;\n  display: flex;\n  padding-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `BV9oRONQig1CEEgqBo7f`,
	"labelDropdown": `pAIekIcNsJco5Wt2f8Id`
};
export default ___CSS_LOADER_EXPORT___;
